// extracted by mini-css-extract-plugin
export default {"profileCont":"ProfileTemplate_profileCont__LfdLo"};